import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';
import { buildValidator } from 'src_common/common/mobx-utils/buildValidator';

const SportIO = t.interface({
    id: t.string,
    name: t.string,
    displayOrder: t.number
});

export type SportModelType = t.TypeOf<typeof SportIO>;

export const isSport = createGuard(SportIO);

export const decodeSportModelFromSocket = buildValidator('API - sportModel from socket', SportIO, true);
